import { defaultApiInstance } from "@/api";

export const eventsService = {
  getEvents,
}

async function getEvents() {
  return await defaultApiInstance.get('events');
}